







































































































import { User } from '@/types';
import Vue from 'vue';

export default Vue.extend({
  props: { value: Boolean },

  data() {
    return {
      menu: this.value,
      signingOut: false,
      signOutWarning: false,
    };
  },

  computed: {
    isAuthenticated(): boolean {
      return this.$store.state.account.isAuthenticated;
    },

    user(): User {
      return this.$store.state.account.user || {};
    },
  },

  watch: {
    menu(value) {
      this.$emit('input', value);
    },

    value(value) {
      this.menu = value;
    },
  },

  methods: {
    requestSignOut() {
      if (this.$store.getters['saveStatus/hasUnsavedWork']) {
        this.signOutWarning = true;
        return;
      }

      this.signOut();
    },

    async signOut() {
      this.signOutWarning = false;
      this.signingOut = true;

      await this.$store.dispatch('account/signOut');

      window.location.reload();
    },
  },
});
